export default __webpack_public_path__ + "static/media/841.31fecba7.png";